import {
  LOAD_TRAFFIC,
  LOAD_WEATHER,
  WIDGET_ERROR
} from '../constants/actionTypes';
// import { totalElements } from '../utils//resources';

const getTime = () => {
  const date = new Date();
  const hour = date.getHours();
  const minutes = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
  return `${hour}:${minutes}`;
};

export const initialState = {
  allWidgetsById: ['traffic', 'weather'],
  byType: {
    traffic: {
      type: 'traffic',
      name: 'Mi tráfico',
      loading: true
    },
    weather: {
      type: 'weather',
      name: 'El Tiempo Hoy',
      loading: true
    }
  }
};

export default (state = initialState, action) => {
  const { type, traffic, weather, payload } = action;

  switch (type) {
    case LOAD_TRAFFIC:
      return {
        ...state,
        byType: {
          ...state.byType,
          traffic: {
            ...traffic,
            ...state.byType.traffic,
            lastUpdate: getTime(),
            loading: false
          }
        }
      };
    case LOAD_WEATHER:
      return {
        ...state,
        byType: {
          ...state.byType,
          weather: {
            ...weather,
            ...state.byType.weather,
            lastUpdate: getTime(),
            loading: false
          }
        }
      };
    case WIDGET_ERROR:
      return {
        ...state,
        byType: {
          ...state.byType,
          [payload.type]: {
            ...state.byType[payload.type],
            type: undefined,
            error: payload.err,
            loading: false
          }
        }
      };
    default:
      return state;
  }
};
